import vueCard from './src/components/cards'

export default vueCard
